import * as React from 'react';
import axios from 'axios';

function pad(num, size){ return ('000000000' + num).substr(-size); }

const API_URL = (window as any).API_URL;

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    axios.get(API_URL + '/courses/1')
      .then( response => {
        this.setState({
          course: response.data.data,
        });
      });
  }

  state = {
    course: null,
    searchText: '',
    isFolded: true,
  }

  handleChangeSearch = (e) => {
    this.setState({
      searchText: e.target.value,
    })
  }

  getFilteredSections = () => {
    const { searchText, course } = this.state;
    if(searchText.trim() == '') return course.sections;
    
    const filtered = course.sections.map( section => {
      return { 
        ...section,
        episodes: section.episodes.filter( episode => episode.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1 ),
      }
    }).filter( section => section.episodes.length != 0 )
    return filtered;
  }

  toggleFolded = () => {
    this.setState({
      isFolded: !this.state.isFolded,
    })
  }

  renderSection = (section,index) => {
    return (
      <li className="_section" key={section.id}>
          <span className="_number">{pad(index+1,2)}</span>
          <h2>{section.name}
            &nbsp;
            <span className="_duration">
              {Math.round(section.duration / 60)} minutes
            </span>
          </h2> 
          <ul className="_episodes">
            {section.episodes.map( episode => (
              <li className="_episode" key={episode.id}>
                <img src={episode.thumbnail_url} />
                <div className="_text">
                  <a href={"/video-course/watch/"+episode.slug}>
                    {episode.name}
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </li>
    );
  }

  render() {
    const { course, searchText, isFolded } = this.state;
    const isLoading = course == null;


    if(isLoading) {
      return (
        <div style={{textAlign: 'center',padding: 50}}>
          <div className="lds-dual-ring"></div>
          <p>Loading course content...</p>
        </div>
      );
    }

    const allSections = this.getFilteredSections();

    let sections;
    if(searchText == '' && isFolded) {
      sections = allSections.slice(0,2);
    } else {
      sections = allSections;
    }


    return (
      <div>
        <form className="_search">
          <input type="textfield" className="_search-input" value={searchText} onChange={this.handleChangeSearch} placeholder="Search all lessons" />
        </form>

       {sections.length == 0 && 
         <p style={{textAlign: 'center', fontSize: '2rem'}}>No matching lessons found - dozens more are in production</p>
       }  
        <ul className="_sections">
          {sections.map((section,index) => this.renderSection(section, index))}
        </ul>



      { !isFolded && <div className="_in-progress">
            <h3>More coming soon</h3>
            <span>New lessons every week</span>
            <ul>
              <li>Ignition</li>
              <li>Exhaust</li>
              <li>Fuel system</li>
              <li>Transmission</li>
              <li>Suspension</li>
              <li>Differential</li>
              <li>Braking</li>
            </ul>
        </div> }

        <div className="show-more">
          <button onClick={this.toggleFolded}>
            {isFolded ? 
              <div>
              See {allSections.map( s => s.episodes).flat().length - sections.map(s => s.episodes).flat().length} more lessons
                <span>&#9660;</span>
              </div> :


              <div>
                <span>&#9650;</span> 
                Show less
              </div>  }

          </button>
        </div>
      </div>
    );
  }
}

export default App;
